import React, { ButtonHTMLAttributes } from 'react';
import './styles.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'auth';
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  fullWidth = false, 
  className = '', 
  ...rest 
}) => {
  return (
    <button 
      className={`button ${variant} ${fullWidth ? 'full-width' : ''} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;